module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-310x310-0265136c7125375ebbd46ce93d78301e.png";